import { message } from "antd";
import { apiClient } from "~/services/apiClient";
import { INTENTS } from "~/utils/constants";
import { EmailObject } from "~/types/email";

export const sendEmail = async (emailObject: EmailObject) => {
  try {
    const result = await apiClient.sendIntent<{ id: string }>(INTENTS._send_mail, {
      emailObject,
    });

    if (!result.success) {
      message.error(result.error ?? "Failed to send email");
      return {
        success: false,
        data: {},
        error: result.error,
      };
    }

    return {
      success: true,
      data: { id: result.data?.id },
    };
  } catch (error: unknown) {
    const err = error as Error;
    message.error(err.message);
    console.error("send email", error);
    return {
      success: false,
      data: {},
      error: err,
    };
  }
};
